import { DataSource, Label, Layout } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageStatusQuickInfo extends Layout {
	LabelID: Label;
	labelActive: Label;
	labelDescription: Label;
	labelLabel1: Label;
	labelLabel4: Label;
	sourceBrokerageStatus: DataSource;
}
